import { z } from 'zod';
import { ForumBody, ForumSortOrder, ForumThreadKind } from './forum.js';
export const ForumThreadEventInput = z.object({
    startsAt: z.string().datetime({ offset: true }),
    endsAt: z.string().datetime({ offset: true }).nullable().optional(),
    allDay: z.boolean().optional(),
    tzid: z.string().min(1).max(64).optional(),
    location: z.string().min(1).max(240).nullable().optional(),
    rsvpCapacity: z.number().int().min(1).max(10000).nullable().optional(),
    rsvpWaitlistEnabled: z.boolean().optional(),
});
export const CreateForumPollRequest = z.object({
    options: z.array(z.string().min(1).max(200)).min(2).max(10),
});
export const CreateForumThreadRequest = z.object({
    groupId: z.string().uuid(),
    groupIds: z.array(z.string().uuid()).max(20).optional(),
    categoryId: z.string().uuid().nullable().optional(),
    kind: ForumThreadKind.optional(),
    title: z.string().min(1).max(180),
    body: ForumBody,
    tags: z.array(z.string().min(1).max(40)).max(12).optional(),
    event: ForumThreadEventInput.nullable().optional(),
    poll: CreateForumPollRequest.nullable().optional(),
});
export const UpdateForumThreadRequest = z
    .object({
    title: z.string().min(1).max(180),
    body: ForumBody,
    groupIds: z.array(z.string().uuid()).max(20),
    tags: z.array(z.string().min(1).max(40)).max(12),
    categoryId: z.string().uuid().nullable(),
    pinned: z.boolean(),
    event: ForumThreadEventInput.nullable(),
})
    .partial();
export const CreateForumPostRequest = z.object({
    parentId: z.string().uuid().nullable().optional(),
    body: ForumBody,
    attachments: z.array(z.unknown()).max(10).optional(),
});
export const UpdateForumPostRequest = z.object({
    body: ForumBody,
    attachments: z.array(z.unknown()).max(10).optional(),
});
export const VoteForumPostRequest = z.object({
    value: z.union([z.literal(-1), z.literal(0), z.literal(1)]),
});
export const ListForumThreadsQuery = z.object({
    group: z.string().uuid().optional(),
    category: z.string().uuid().optional(),
    kind: ForumThreadKind.optional(),
    sort: ForumSortOrder.optional(),
    q: z.string().min(1).max(200).optional(),
    tag: z.string().min(1).max(40).optional(),
    includeHidden: z.boolean().optional(),
    limit: z.number().int().min(1).max(100).optional(),
    offset: z.number().int().min(0).optional(),
});
export const ListForumCategoriesQuery = z.object({
    group: z.string().uuid(),
    includeArchived: z.boolean().optional(),
});
export const CreateForumCategoryRequest = z.object({
    groupId: z.string().uuid(),
    name: z.string().min(1).max(80),
    description: z.string().min(1).max(500).nullable().optional(),
    position: z.number().int().optional(),
    readOnly: z.boolean().optional(),
    moderatorOnly: z.boolean().optional(),
});
export const UpdateForumCategoryRequest = z
    .object({
    name: z.string().min(1).max(80),
    description: z.string().min(1).max(500).nullable(),
    position: z.number().int(),
    readOnly: z.boolean(),
    moderatorOnly: z.boolean(),
    archived: z.boolean(),
})
    .partial();
export const ForumModerationRequest = z.object({
    reason: z.string().max(500).optional(),
});
export const MoveForumThreadRequest = z.object({
    groupId: z.string().uuid(),
    reason: z.string().max(500).optional(),
});
export const VoteForumPollRequest = z.object({
    optionId: z.string().uuid().nullable(),
});
export const SetForumEventRsvpStatus = z.enum(['going', 'maybe', 'declined']);
export const SetForumEventRsvpRequest = z.object({
    status: SetForumEventRsvpStatus.nullable(),
    note: z.string().max(500).nullable().optional(),
});
//# sourceMappingURL=requests.js.map